import { AppGroup, IncompleteSetupReason, } from '@wix/ambassador-marketplace/types';
function isAppSetupIncomplete(app, experiments) {
    if (!app || !experiments) {
        return false;
    }
    var isHybridAppPending = app.group === AppGroup.PENDING;
    var isSetupIncomplete = app.incompleteSetupReason === IncompleteSetupReason.PENDING_CONFIGURATION;
    return (experiments.enabled('specs.marketplace.complete-setup') &&
        isSetupIncomplete &&
        !isHybridAppPending);
}
export { isAppSetupIncomplete };
//# sourceMappingURL=is-app-setup-incomplete.js.map